import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import { editMeetingBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { IMeetingBlockEditModel } from 'models/block.model'
import * as fromActions from '../../../actions/blocks.action'
import { EditMeetingBlockPayload } from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}
async function editMeeting(blockId: number, blockDetails: any) {
  return editMeetingBlock(blockId, blockDetails)
}

const pattern = fromActions.EDIT_MEETING_BLOCK

function* editMeetingBlockEffectSaga(
  action: ActionWithPayload<typeof pattern, EditMeetingBlockPayload>
) {
  try {
    const {
      payload: {
        id,
        lessonId,
        title,
        description,
        config,
        startTime,
        duration,
        typeMeet,
        integrationType,
        timezone,
      },
    } = action

    const blockDetails: IMeetingBlockEditModel = {
      block_meeting: {
        title,
        description,
        config,
        startTime,
        duration,
        typeMeet,
        integrationType,
        timezone,
      },
      block_instance: {
        lesson_id: lessonId,
        name: title,
      },
    }
    yield call(editMeeting, id, blockDetails)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editMeetingBlockWatcherSaga() {
  yield takeLatest(pattern, editMeetingBlockEffectSaga)
}
